import { ARFunction } from '../../';
import { Parameter } from '../../Parameter/Parameter';
import { signals } from '../ARFunction';


function newBalance({balance, apr, payment} = {}) {
  if (balance.lag(1) === 0) {
    return signals.BREAK_ITERATIONS;
  } else if (!(balance && payment)) {
    return null;
  }

  let value = balance.lag(1)
      + apr / 12 * balance.lag(1)
      - payment;
  
  return Math.max(value, 0.0);
}

export const loanPaydown = new ARFunction(
  newBalance,
  {
    label: 'Calculate the Balance of a Loan',
    parameters: [
      new Parameter({name: 'balance', type: 'self'}),
      new Parameter({name: 'apr', type: 'number'}),
      new Parameter({name: 'payment', type: 'number'})
    ]
  }
);